import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-document-modal',
  templateUrl: './document-modal.page.html',
  styleUrls: ['./document-modal.page.scss'],
})
export class DocumentModalPage implements OnInit {
  document: any;
  phone: any;

  constructor(private modalController: ModalController) {
  }

  ngOnInit() {
  }

  async close() {
    await this.modalController.dismiss({});
  }

  async saveData(value: any) {
    await this.modalController.dismiss(value);

  }
  validateOnlyNumbers() {
    if (this.document) {
      this.document = String(this.document).replace(/\D/g, '');
    }
    if(this.phone){
      this.phone = String(this.phone).replace(/\D/g, '');
    }
  }
}
